import {
  Card,
  Col,
  Row,
  Typography,
  Table,
  Button,
  Tooltip,
  Image,
  Avatar,
  DatePicker,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import React, { useContext, useEffect, useState } from "react";
import { ShowToast, Severty } from "../../helper/toast";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import UploadsAnalyticsChart from "../../components/charts/UploadsAnalyticsChart.jsx";
import SkillTagChart from "../../components/charts/SkillTagChart.jsx";
import RoleDistributionChart from "../../components/charts/RoleDistributionChart.jsx";
import GlobalSearch from "../../components/GlobalSearch.js";
import lang from "../../helper/lang";
import ViewAPost from "../Post/ViewAPost";
import { EyeOutlined } from "@ant-design/icons";
import { AuthContext } from "../../context/AuthContext.js";
import { USERTYPE } from "../../constants/conts.js";

function Home() {
  const { Title } = Typography;
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  const [postViewModal, setPostViewModal] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [postId, setPostId] = useState("");
  const navigate = useNavigate();
  const routeName = "customer";

  const view = (id) => {
    navigate(`/user/${routeName}/view/${id}`);
  };

  const [dashboard, setDashboard] = useState({});
  const { RangePicker } = DatePicker;
  // ------------- KPIs Cards -----------------
  const count = [
    {
      today: `Total Users`,
      title: `${dashboard.kpis?.totalUsers ?? 0}`,
      persent: "10%",
      icon: <i className="fas fa-users"></i>,
      bnb: "bnb2",
      url: "/admin/user-manager",
    },
    {
      today: `New Users`,
      title: `${dashboard.kpis?.newUsers ?? 0}`,
      persent: "10%",
      icon: <i className="fas fa-user-plus"></i>,
      bnb: "bnb2",
      url: "/admin/user-manager",
    },
    {
      today: `Daily Active Users (DAU)`,
      title: `${dashboard.kpis?.dau ?? 0}`,
      icon: <i className="fas fa-user-clock"></i>,
      bnb: "bnb2",
      url: "/admin/session-manager",
    },
    {
      today: `Weekly Active Users (WAU)`,
      title: `${dashboard.kpis?.wau ?? 0}`,
      icon: <i className="fas fa-user-check"></i>,
      bnb: "bnb2",
      url: "/admin/session-manager",
    },
    {
      today: `Monthly Active Users (MAU)`,
      title: `${dashboard.kpis?.mau ?? 0}`,
      icon: <i className="fas fa-users-cog"></i>,
      bnb: "bnb2",
      url: "/admin/session-manager",
    },
    {
      today: `Total Coaches`,
      title: `${dashboard.kpis?.totalCoaches ?? 0}`,
      icon: <i className="fas fa-user-tie"></i>,
      bnb: "bnb2",
      url: "/admin/coach-manager",
    },
    {
      today: `Total Academies`,
      title: `${dashboard.kpis?.totalAcademies ?? 0}`,
      icon: <i className="fas fa-graduation-cap"></i>,
      bnb: "bnb2",
      url: "/admin/academy-manager",
    },
    {
      today: `Total Matches`,
      title: `${dashboard.kpis?.totalMatches ?? 0}`,
      icon: <i className="fas fa-trophy"></i>,
      bnb: "bnb2",
      url: "/admin/tournaments",
    },
    {
      today: `Total Posts/Videos`,
      title: `${dashboard?.kpis?.totalPosts ?? 0}`,
      persent: "10%",
      icon: <i className="fas fa-store"></i>,
      bnb: "bnb2",
      url: "/admin/post-manager",
    },
    {
      today: `Total Groups`,
      title: `${dashboard.kpis?.totalGroups ?? 0}`,
      icon: <i className="far fa-building"></i>,
      bnb: "bnb2",
      url: "/admin/group-manager",
    },

  ];

  const postsColumn = [
    {
      title: `Post Id`,
      dataIndex: "postId",
      key: "postId",
      render: (_, { postId }) => {
        return (
          <a className="cap avatar-text column-avatar-text">
            {postId ? postId : "Not Available"}
          </a>
        );
      },
    },
    {
      title: `Caption`,
      dataIndex: "caption",
      key: "caption",
      render: (_, { caption }) => {
        return <span className="cap">{caption}</span>;
      },
    },
    {
      title: `Likes`,
      dataIndex: "likes",
      key: "likes",
      render: (_, { likes }) => {
        return <span className="cap">{likes ?? 0}</span>;
      },
    },

    {
      title: `Category`,
      dataIndex: "category",
      key: "category",
      render: (_, { category }) => {
        return <span className="cap">{category}</span>;
      },
    },
    {
      title: `Created On`,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, { createdAt }) => {
        return moment(createdAt).format("YYYY-MM-DD");
      },
    },
  ];

  const groupsColumn = [
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name, image, _id }) => {
        return (
          <div className="main-new-image-and-text-oki9profile">
            {image ? (
              <Image className="image-index-radius" src={image} />
            ) : (
              <span className="image-fallback">
                {name ? name.charAt(0).toUpperCase() : "N/A"}
              </span>
            )}
            <a className="cap avatar-text column-avatar-text">
              {name ? name : "N/A"}
            </a>
          </div>
        );
      },
    },
    {
      title: `Members`,
      dataIndex: "members",
      key: "members",
      render: (_, { members }) => {
        return <span className="cap">{members.length}</span>;
      },
    },
    {
      title: `Post Count`,
      dataIndex: "postsCount",
      key: "postsCount",
      render: (_, { postsCount }) => {
        return <span className="cap">{postsCount ?? 0}</span>;
      },
    },
  ];

  const winnerColumn = [
    {
      title: `Winner Name`,
      dataIndex: "userName",
      key: "userName",
      render: (_, { userName, user_id, image }) => {
        return (
          <>
            {!image ? (
              <>
                <Avatar className="cap" size={40}>
                  {userName ? userName.charAt(0) : "Not Available"}
                </Avatar>
                <a className="cap avatar-text" onClick={(e) => view(user_id)}>
                  {userName ? userName : "Not Available"}
                </a>
              </>
            ) : (
              <>
                <Image className="image-index-radius" src={image} />
                <a className="cap avatar-text" onClick={(e) => view(user_id)}>
                  {userName ? userName : "Not Available"}
                </a>
              </>
            )}
          </>
        );
      },
    },
    {
      title: `Winning Email`,
      dataIndex: "email",
      key: "email",
    },
    {
      title: `Winning Amount(₹)`,
      dataIndex: "wining_amount",
      key: "wining_amount",
      render: (_, { wining_amount }) => `₹${wining_amount || 0}`,
    },
    {
      title: `Contest Name`,
      dataIndex: "contestName",
      key: "contestName",
      render: (_, { contestName }) => contestName || "-",
    },
    {
      title: `${lang("Winner Date")}`,
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("lll");
      },
    },
    {
      title: `View Post`,
      render: (_, { _id }) => (
        <>
          <Tooltip title="View Post">
            <Button
              onClick={() => {
                setPostId(_id);
                setPostViewModal(true);
              }}
            >
              <EyeOutlined />
            </Button>
          </Tooltip>
        </>
      ),
    },
  ];

  const topActiveUsers = [
    {
      title: `Name`,
      dataIndex: "name",
      key: "name",
      render: (_, { name, image, _id }) => {
        return (
          <>
            {!image ? (
              <>
                <Avatar className="cap" src={image} size={40}>
                  {name?.charAt(0)}
                </Avatar>
                {/* <a className="cap avatar-text" onClick={(e) => view(userDetails?._id)}> */}
                <a className="cap avatar-text">
                  {name ? name : "Not Available"}
                </a>
              </>
            ) : (
              <>
                <Image className="image-index-radius" src={image} />
                <a className="cap avatar-text column-avatar-text">
                  {name ? name : "Not Available"}
                </a>
              </>
            )}
          </>
        );
      },
    },
    {
      title: `Username`,
      dataIndex: "username",
      key: "username",
      render: (_, { username }) => username || "-",
    },
    {
      title: `Total Posts`,
      dataIndex: "posts",
      key: "posts",
      render: (_, { posts }) => (
        <span className="your-caption-class">{posts || "-"}</span>
      ),
    },
    {
      title: `Last Active`,
      dataIndex: "lastActive",
      key: "lastActive",
      render: (_, { lastActive }) => {
        return lastActive ? moment(lastActive).format("YYYY-MM-DD") : 0;
      },
    },
  ];

  const handleChangeDate = (dates) => {
    if (!dates) {
      setStartDate();
      setEndDate();
    } else {
      setStartDate(moment(dates[0]).format("YYYY-MM-DD"));
      setEndDate(moment(dates[1]).format("YYYY-MM-DD"));
    }
  };

  const mostEngagedUsers = [
    {
      title: `Name`,
      dataIndex: "name",
      key: "name",
      render: (_, { name, image, _id }) => {
        return (
          <>
            {!image ? (
              <>
                <Avatar className="cap" src={image} size={40}>
                  {name?.charAt(0)}
                </Avatar>
                <a className="cap avatar-text">
                  {name ? name : "Not Available"}
                </a>
              </>
            ) : (
              <>
                <Image className="image-index-radius" src={image} />
                <a className="cap avatar-text column-avatar-text">
                  {name ? name : "Not Available"}
                </a>
              </>
            )}
          </>
        );
      },
    },
    {
      title: `Username`,
      dataIndex: "username",
      key: "username",
      render: (_, { username }) => username || "-",
    },
    {
      title: `Like Received`,
      dataIndex: "likesReceived",
      key: "likesReceived",
      render: (_, { likesReceived }) => (
        <span className="your-caption-class">{likesReceived ?? 0}</span>
      ),
    },
  ];

  // ------------ Module Permissions ------------
  const { userProfile, userPermission } = useContext(AuthContext);
  const isSuperAdmin = userProfile?.role === USERTYPE.SUPER_ADMIN;
  const skillTagPermission =
    isSuperAdmin || userPermission?.TAG_MANAGER?.enabled === true;
  const rolePermission =
    isSuperAdmin || userPermission?.ROLE_MANAGER?.enabled === true;
  const postPermission =
    isSuperAdmin || userPermission?.POST_MANAGER?.enabled === true;
  const groupPermission =
    isSuperAdmin || userPermission?.GROUP_MANAGER?.enabled === true;
  const usersPermission =
    isSuperAdmin || userPermission?.USER_MANAGER?.enabled === true;

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      // 📅 Date filters
      if (startDate) {
        params.append("startDate", startDate);
      }

      if (endDate) {
        params.append("endDate", endDate);
      }
      request({
        url: `${apiPath.dashboard}?${params.toString()}`,
        method: "GET",
        onSuccess: (data) => {
          setLoading(false);
          setDashboard(data.data);
        },

        onError: (error) => {
          setLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    } catch (error) {
      console.log("Error occured while getting dashboard data", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return (
    <>
      <div className="global-search-div">
        <GlobalSearch />
        <RangePicker
          disabledDate={(current) =>
            current && current.isAfter(moment().endOf("day"))
          }
          onChange={handleChangeDate}
        />
      </div>
      <div className="layout-content">
        <div className="mb-24">
          <Row gutter={[16, 24]}>
            <Col xs={24} sm={24} md={24}>
              <Row
                className="rowgap-vbox"
                gutter={[16, 24]}
                style={{ marginLeft: "0" }}
              >
                {count.map((c, index) => (
                  <Col
                    key={index}
                    xs={24}
                    sm={12}
                    md={8}
                    lg={6}
                    xl={4}
                    className=" dashbord-main-4545 five-cards-col"
                  >
                    <Link to={c.url} state={c.state}>
                      <Card
                        bordered={false}
                        className="criclebox"
                        style={{ height: "100%" }}
                      >
                        <div className="number">
                          <Row align="middle" gutter={[24, 24]}>
                            <Col xs={18}>
                              <span>{c.today}</span>
                              <Title level={3}>{c.title}</Title>
                            </Col>
                            <Col xs={6}>
                              <div className="icon-box">{c.icon}</div>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>
        <Row gutter={[24, 16]}>
          {/* Charts */}
          <UploadsAnalyticsChart
            chartData={dashboard.charts?.uploadsPerDay}
          />


          {/* Role Distribution Chart */}
          <RoleDistributionChart
            chartData={dashboard.charts?.roleDistribution}
            rolePermission={rolePermission}
            onViewReport={() => navigate("/admin/role-manager")}
          />

          {/* Skill Tag Chart */}
          <SkillTagChart
            chartData={dashboard.charts?.skillTags}
            skillTagPermission={skillTagPermission}
            onViewReport={() => navigate("/admin/tag-manager")}
          />
          {/* Most Engagged Users */}
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace"
              style={{ marginBottom: "16px" }}
            >
              <div className="dashboard-tables-main-heading">
                <p className="dashboard-table-heading">Most Engagged Users</p>
                {usersPermission ? (
                  <Button onClick={() => navigate("/admin/user-manager")}>
                    View Detailed Report
                  </Button>
                ) : (
                  ""
                )}
              </div>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={mostEngagedUsers}
                  dataSource={dashboard?.mostEngagedUsers || []}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        {/* Top 10 Active Users */}
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace"
              style={{ marginBottom: "16px" }}
            >
              <div className="dashboard-tables-main-heading">
                <p className="dashboard-table-heading">Top Active Users</p>
                {usersPermission ? (
                  <Button onClick={() => navigate("/admin/user-manager")}>
                    View Detailed Report
                  </Button>
                ) : (
                  ""
                )}
              </div>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={topActiveUsers}
                  dataSource={dashboard?.topActiveUsers || []}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        {/*Recent 10 Posts */}
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace"
              style={{ marginBottom: "16px" }}
            >
              <div className="dashboard-tables-main-heading">
                <p className="dashboard-table-heading">Top 10 Posts</p>
                {postPermission ? (
                  <Button onClick={() => navigate("/admin/post-manager")}>
                    View Detailed Report
                  </Button>
                ) : (
                  ""
                )}
              </div>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={postsColumn}
                  dataSource={dashboard?.topPosts || []}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        {/*Recent 10 Groups */}
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace"
              style={{ marginBottom: "16px" }}
            >
              <div className="dashboard-tables-main-heading">
                <p className="dashboard-table-heading">Top 10 Groups</p>
                {groupPermission ? (
                  <Button onClick={() => navigate("/admin/group-manager")}>
                    View Detailed Report
                  </Button>
                ) : (
                  ""
                )}
              </div>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={groupsColumn}
                  dataSource={dashboard?.topGroups || []}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        <ViewAPost
          isOpen={postViewModal}
          setIsOpen={setPostViewModal}
          setLoading={setLoading}
          postId={postId}
        />
      </div>
    </>
  );
}

export default Home;
